/** Allows to manage events in a better way
 * @constructor eventType (the type of event you want to manage)
 * @constructor callBack (the function that will be called when the event happens)
 * @constructor observe (the element that will be observed; by default it's window)
 */
var EventManager = /** @class */ (function () {
    function EventManager(eventType, callBack, observe) {
        var _this = this;
        this.observe = window;
        this._activateOnLoad = false;
        this._options = null;
        /** Fires the event when the "register" method is called
         * @returns this
         */
        this.activateOnRegister = function () {
            _this._activateOnLoad = true;
            return _this;
        };
        /** Allows to add options to the event
         * @param options boolean or EventListenerOptions
         * @returns this
         */
        this.addOptions = function (options) {
            _this._options = options;
            return _this;
        };
        /** Registers the event; usually called on component mount
         * @returns this
         */
        this.register = function () {
            if (_this._activateOnLoad)
                _this.callBack(new Event("load"));
            _this.observe.addEventListener(_this.eventType, _this.callBack, _this._options);
            return _this;
        };
        /** Unregisters the event; usually called on component unmount
         * @returns this
         */
        this.unregister = function () { return _this.observe.removeEventListener(_this.eventType, _this.callBack, _this._options); };
        this.eventType = eventType;
        this.callBack = function (e) { return callBack(e); };
        if (observe)
            this.observe = observe;
    }
    return EventManager;
}());
export { EventManager };
/** Adds an EventManager instance to a list
 * @param list EventManager[]
 * @param newElement EventManager
 */
export var addToRegister = function (list, newElement) { return list.push(newElement.register()); };
/** Given a list of EventManager, unregisters all its events
 * @param list EventManager[]
 */
export var unregisterAll = function (list) { return list.forEach(function (e) { return e.unregister(); }); };
